import React from 'react'
import { Card as SemanticCard } from 'semantic-ui-react'

type CardProps = React.ComponentPropsWithoutRef<typeof SemanticCard> & {
  active?: boolean
  disabled?: boolean
}

export const Card: React.FC<CardProps> = ({
  className = '',
  active,
  disabled,
  onClick,
  children,
  ...props
}) => (
  <SemanticCard
    {...props}
    className={`${className} ${active ? '!shadow-blue' : ''} pointer-events-${
      disabled ? 'none' : 'auto'
    }`}
    onClick={onClick}
  >
    {children}
  </SemanticCard>
)

export const CardContent = SemanticCard.Content
export const CardDescription = SemanticCard.Description
export const CardHeader = SemanticCard.Header
export const CardGroup = SemanticCard.Group



// WEBPACK FOOTER //
// ./src/components/Card/index.tsx